import { Modal, Button } from "antd";
import moment from "moment";
import { PREFERRED_DATE_FORMAT } from "../../util/time";

export const LoaConfirmationModal = ({
                                       visible,
                                       onCancel,
                                       onConfirm,
                                       employeeName,
                                       currentResourceType,
                                       leaveType,
                                       postResourceType,
                                       startDate,
                                       endDate,
                                       totalLeaveHours
                                     }) => (
  <Modal
    title="Confirmation: Change of Resource Type"
    open={visible}
    onCancel={onCancel}
    footer={[
      <Button key="ok" type="primary" onClick={onCancel}>
        Cancel
      </Button>,
      <Button key="confirm" type="primary" onClick={onConfirm}>
        Confirm
      </Button>,
    ]}
  >
    <p>
      Employee Name: {employeeName}<br/>
      Current Resource Type: {currentResourceType}<br/>
      Leave Type: {leaveType}<br/>
      Post Resource Type: {postResourceType}<br/>
      Start Date: {startDate}<br/>
      {endDate &&
        <>
          End Date: {endDate}<br/>
          Total Leave Hours: {totalLeaveHours}<br/>
        </>
      }
    </p>
    <p>Upon submitting this Leave of Absence request beginning on {startDate}, a month in advance, the
      resource history records will reflect the resource type change
      from {currentResourceType} to {leaveType} on {startDate}, and the time off cards will be populated with {leaveType}.</p>
    {endDate ?
      <p>The resource will automatically change
        to {postResourceType} on {moment(endDate, 'MM/DD/YYYY').add(1, 'day').format(PREFERRED_DATE_FORMAT)}.</p> :
      <p>The resource will remain in {leaveType} until an end date is entered or the resource is manually changed
        in
        Projector.</p>
    }
    {currentResourceType !== postResourceType && (
      <p style={{ color: "red" }}>
        Warning: The Current Resource Type and Post Resource Type do not match. Ignore if this is intended.
      </p>
    )}
  </Modal>
);